export const BACK_END_SUCCESS_OPERATION = 'serviceMessages:back_end_success_operation';
export const BACK_END_ACTION_SUCCESS = 'serviceMessages:back_end_action_success';
export const CREATED_LABEL = 'serviceMessages:created_label';
export const UPDATED_LABEL = 'serviceMessages:updated_label';
export const DELETED_LABEL = 'serviceMessages:deleted_label';
export const FILE_LABEL = 'serviceMessages:file_label';
export const SEMESTER_SERVICE_IS_ACTIVE = 'serviceMessages:semester_service_is_active';
export const SEMESTER_SERVICE_NOT_AS_BEGIN_OR_END =
    'serviceMessages:semester_service_not_as_begin_or_end';
export const FILE_BACK_END_SUCCESS_OPERATION = 'serviceMessages:file_backend_success_operation';
export const COPIED_LABEL = 'serviceMessages:copied_label';
export const ARCHIVED_LABEL = 'serviceMessages:archived_label';
export const CLEARED_LABEL = 'serviceMessages:cleared_label';
export const SERVICE_MESSAGE_GROUP_LABEL = 'serviceMessages:group_label';
export const CHOSEN_SEMESTER_HAS_NOT_GROUPS = 'serviceMessages:chosen_semester_has_not_groups';
export const SERVICE_MESSAGE_SENT_LABEL = 'serviceMessages:sent_label';
export const EXIST_LABEL = 'serviceMessages:exist_label';
export const GROUP_EXIST_IN_THIS_SEMESTER = 'serviceMessages:group_exist_in_this_semester';
export const STUDENTS_EXIST_IN_THIS_GROUP = 'serviceMessages:students_exist_in_this_group';
export const MOVED_TO_GROUP_LABEL = 'serviceMessages:moved_to_group';
